
class CountdownTimer {
    constructor(startDate, endDate, timezone, element, timer_end_label) {
      this.startDate = new Date(startDate);
      this.endDate = new Date(endDate);
      this.timezone = timezone;
      this.element = element;
      this.timer_end_label = timer_end_label;
      this.timer = null;
      this.tick();
      this.startCountdown();
      
    }
  
    calculateTimeRemaining() {
      const now = new Date().toLocaleString('en-US', { timeZone: this.timezone });
      const diff = new Date(this.endDate) - new Date(now);
  
      
      if (diff <= 0) {
        clearInterval(this.timer);
        return {
          weeks: 0,
          days: 0,
          hours: 0,
          minutes: 0,
          seconds: 0
        };
      }
      const weeks = this.two_places(Math.floor(diff / (1000 * 60 * 60 * 24 * 7)));
      const days = this.two_places(Math.floor((diff % (1000 * 60 * 60 * 24 * 7)) / (1000 * 60 * 60 * 24)));
      const hours = this.two_places(Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)));
      const minutes = this.two_places(Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60)));
      const seconds = this.two_places(Math.floor((diff % (1000 * 60)) / 1000));
      return {
        weeks,
        days,
        hours,
        minutes,
        seconds
      };
    }
  
    two_places(number){
      this.number = number;
  
      if(this.number < 10 ){
        return `0${this.number}`;
      }else{
        return `${this.number}`;
      }
    }
  
    tick() {
      this.timer = setInterval(() => {
      
        const timeRemaining = this.calculateTimeRemaining();
        const countdownElement = this.element;
        countdownElement.innerHTML = `
          <div class="countdown_count weeks"> <span class="counter"> ${timeRemaining.weeks} </span> <span class="counter-label"> WEEKS </span> </div>
          <div class="countdown_count days"> <span class="counter"> ${timeRemaining.days} </span> <span class="counter-label"> DAYS </span> </div>
          <div class="countdown_count hours"> <span class="counter"> ${timeRemaining.hours} </span> <span class="counter-label"> HRS </span> </div>
          <div class="countdown_count mins"> <span class="counter"> ${timeRemaining.minutes}  </span> <span class="counter-label"> MINS </span> </div>
          <div class="countdown_count secs"> <span class="counter"> ${timeRemaining.seconds} </span>  <span class="counter-label">  SECS </span> </div>
        `;
      }, 1000);
    }
  
    startCountdown() {
      const now = new Date().toLocaleString('en-US', { timeZone: this.timezone });
  
      if (new Date(now) < new Date(this.endDate)) {
        this.tick();
      } else {
        clearInterval(this.timer);
        const countdownElement = this.element;
        countdownElement.innerHTML = this.timer_end_label;
      }
    }
  }
  
  
  // Find all elements with the "countdown" class
  const countdownElements = document.getElementsByClassName('countdown');
  
  // Function to create countdown timers
  function createCountdownTimer(element) {
    const timer_end_label = element.dataset.timer_bar_timer_end;
    const endDate = element.dataset.end;
  
    const timezone = 'America/New_York';
    const startDate = `2023/01/01 00:00`;
    
    const timer = new CountdownTimer(startDate, endDate, timezone, element, timer_end_label);

  }
  
  // Iterate through each element and create countdown timers
  Array.from(countdownElements).forEach(element => {
    createCountdownTimer(element);
  });